import React, { useEffect, useState } from "react";
import t from "../../service/translate.service";
import "./index.css";
import { inject, observer } from "mobx-react";
import { api } from "../../service/api.service";
import LoadingPageOverlay from "../../components/LoadingPageOverlay";
import { extractError } from "../../service/response.service";
import { Alert } from "antd";
import { useNavigate, useParams } from "react-router-dom";


const VouchersPreview = () => {
  const navigate = useNavigate()
  const { fileName, contractNumber } = useParams()
  const [loading, setLoading] = useState(false);
  const [document, setDocument] = useState(null);
  const [error, setError] = useState('');

  const getDocument = async (contractNumber, fileName) => {
    setLoading(true)
    const res = await api.get(`/vouchers/${contractNumber}/${fileName}/file`, {
      responseType: 'blob',
    }).then((res) => {
      setError('')
      return res
    })
    .catch((error) => {
      setError(t[extractError(error)] || t["ERROR"])
    });
    setLoading(false)
    return res.data
  }

  const setDocumentData = async (contractNumber, fileName) => {
    const file = await getDocument(contractNumber, fileName);
    setDocument(file)
  }

  useEffect(() => {
    window.scrollTo(0, 0);
    (async () => {
      await setDocumentData(contractNumber, fileName)
    })()
  }, []);

  if (loading) return <LoadingPageOverlay />;
  return (
    <div className="vouchers-page-wrap">
      {error && <Alert message={error} type='error' style={{marginTop: '12px', marginBottom: '12px'}} />}
      {document && (
        <div className='position-relative' style={{minHeight: '900px'}}>
          <div className='document-preview'>
            <button className='close-preview' onClick={() => navigate('/vouchers')}>x</button>
            <div style={{paddingLeft: '20px', paddingRight: '20px'}} className='text-center'>
              <iframe src={URL.createObjectURL(document)} sandbox toolbar='false'/>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default inject("contractStore")(observer(VouchersPreview));
